import React from 'react'
import HeroSection from '../OutletTemplate/HeroSection'
import CaseStudiesSection from '../HomeLanding/ComponentsIndiaPage/CaseStudiesSection'
import NewFaqSection from '../HomeLanding/HomeLandingComponents/NewFaqSection'
import NewsAndVideos from '../HomeLanding/ComponentsIndiaPage/NewsAndVideos'
import FeaturesSection from '../OutletTemplate/FeaturesSection'
import styles from '../.././styles/outletTemplate.module.css'
import GetFreeTrial from '../OutletTemplate/GetFreeTrial'
import ReviewsSection from '../HomeLanding/ComponentsIndiaPage/ReviewsSection'
import BusinessUnlockSection from '../HomeLanding/ComponentsIndiaPage/BusinessUnlockSection'
import ConnectWithUs from '../HomeLanding/ComponentsIndiaPage/ConnectWithUs'
import { MarqueeComponentHomePage, NewMarqueeComponentHomePageIndia } from '../qbStrap'
import Image from 'next/image'

const HomeLivingDesktop = () => {
    const topSection = [
        {
            title: <>POS Billing Software for  <br />Home Decor & Furniture Shops</>,
            text: "Frame your store’s operations with the same precision you bring to every curated house corner. QueueBuster’s POS Billing Software for Home & Living Stores is crafted to simplify billing, manage diverse inventory, and elevate customer experience. Whether you're running a cozy home décor boutique or a multi-brand furniture outlet, manage it all with the same elegance you offer your customers.",
            centerImage: "/assets/HomeDecor/HomeDecor_image.webp",
            height: "35rem",
            width: "70rem",
            top: "-20rem",

            Image1: {
                src: "/assets/HomeDecor/Chart.svg",
                alt: "  Image",
                width: "33rem",
                height: "15rem",
                left: "10rem",
                bottom: "18rem",


            },
            Image2: {
                src: "/assets/HomeDecor/ItemCard.svg",
                alt: "  Image",
                width: "14rem",
                height: "16rem",
                bottom: "24rem",
                right: "23rem",
                zIndex: 4

            },
            Image3: {
                src: "/assets/HomeDecor/HomeDecor3.svg",
                alt: " Image 1",
                width: "22rem",
                height: "7rem",
                bottom: "5rem",
                left: "38%",
                zIndex: 4

            },
            Image4: {
                src: "/assets/HomeDecor/HomeDecor4.svg",
                alt: "  Image 1",
                width: "4rem",
                height: "4rem",
                bottom: "34rem",
                left: "15rem",
            },
        }
    ]

    const faqs = [
        {
            para: (
                <span style={{ width: "90%" }}>
                Why is QueueBuster POS ideal for home & furniture shops?
                </span>
            ),
            des: "Because it helps you manage a large variety of SKUs, complex pricing, and high-value items – while simplifying billing, inventory, and customer engagement.",
            id: 1,
            activeIndex: 1,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                   Can it handle different product categories and combos?
                </span>
            ),
            des: "Yes. You can manage furniture, furnishings, lighting, and more, including product bundling and combo offers.",
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                  Does it support inventory for both showroom and warehouse?
                </span>
            ),
            des: "Absolutely. You can sync inventory across multiple locations and manage stock transfers between them.",
            id: 3,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                 Can it manage custom or made-to-order products?
                </span>
            ),
            des: "Yes. You can define BOMs (Bill of Materials), track production components, and update inventory in real-time.",
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                  Is it suitable for small boutiques and large chains?
                </span>
            ),
            des: "Yes. Whether you're running a boutique decor store or a multi-location furniture outlet, QueueBuster scales with your needs.",
            id: 5,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                   How does the system help in reducing stock mismanagement?
                </span>
            ),
            des: "With real-time stock tracking, low-stock alerts, and audit logs, you minimize pilferage, overstocking, and dead inventory.",
            id: 6,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                   Can I track customer preferences or favorite products?
                </span>
            ),
            des: "Yes, the CRM tracks customer purchase history, helping you personalize offers or recommend similar/new products.",
            id: 7,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                   Is there a mobile app to manage my store on the go?
                </span>
            ),
            des: "Yes. QueueBuster offers a mobile app for owners and managers to view sales reports, check inventory, or approve discounts remotely.",
            id: 8,
            activeIndex: 0,
        },
    ]
    const Data = {
        centerImage1: "/assets/HomeDecor/Center_image.webp",
        data: [
            {
                id: 1,
                image: "/assets/HomeDecor/billing_img.webp",
                icon: "/assets/petStore/Point_of_sale.svg",
                title: "Fast, flexible billing for every aisle",
                tag: "Point of Sale",
                desc: "Whether you're selling furniture, home décor, lighting, or home essentials, QueueBuster’s POS is designed to simplify checkouts and support flexible billing needs.",
                btnText: "Speak with an expert",
                imageWidth: "46rem",
                imageHeight: "40.3rem",
                 
                Image2: {
                    src: "/assets/HomeDecor/sofa.svg",
                    alt: "Pet Store Image 1",
                    imageWidth: "14rem",
                    imageHeight: "14rem",
                    bottom: "10rem",
                    right: "2rem",
                },
                Image3: {
                    src: "/assets/HomeDecor/Taxes.svg",
                    alt: "Pet Store Image 3",
                    imageWidth: "20rem",
                    imageHeight: "20rem",
                    top: "3rem",
                    left: "0rem",
                },

                Image4: {
                    src: "/assets/HomeDecor/sofaprice.svg",
                    alt: "Pet Store Image 2",
                    imageWidth: "24rem",
                    imageHeight: "8rem",
                    left: "0rem",
                    bottom: "1rem",

                },
               

                points: [
                    <>Scan & bill furniture, décor, or accessories in seconds </>,
                    <>Support for barcoded & non-barcoded SKUs</>,
                    <>Bundle products into sets (e.g. dining sets or decor combos)</>,
                    <>Manage returns, exchanges, and custom pricing with ease</>,
                    <>Accept UPI, cards, EMI, wallets, or cash, all from one screen</>
                ],
            },
            {
                id: 2,
                image: "/assets/HomeDecor/Track_everything.webp",
                tag: "Inventory Management",
                icon: "/assets/petStore/Inventory.svg",
                title: "Track everything from cushions to cabinets",
                desc: "Keep stock in check across categories, sizes, and styles. From handcrafted décor to bulk sofa sets, you’ll always know what’s in, what’s moving, and what needs reordering.",
                btnText: "Request a callback",
                imageWidth: "46rem",
                imageHeight: "40.3rem",
                Image1: {
                    src: "/assets/HomeDecor/frame1.svg",
                    alt: "Pet Store Image 1",
                    imageWidth: "6rem",
                    imageHeight: "6rem",
                    top: "3rem",
                    right: "20%",
                    
                },
                Image2: {
                    src: "/assets/HomeDecor/table.svg",
                    alt: "Pet Store Image 2",
                    imageWidth: "30rem",
                    imageHeight: "18rem",
                    bottom: "2rem",
                    right: "1rem",
                     
                },
                Image3: {
                    src: "/assets/HomeDecor/updated.svg",
                    alt: "Pet Store Image 2",
                    imageWidth: "15rem",
                    imageHeight: "15rem",
                    left: "0rem",
                    top: "6rem",
                     
                },
                

                points: [
                    <>Real-time inventory sync across store & warehouse </>,
                    <>Track by SKU, batch, brand, or category</>,
                    <>Get low-stock & out-of-stock alerts </>,
                    <>Manage vendor purchases and incoming shipments</>,
                    <>Handle made-to-order items with component tracking</>
                ],
            },
            {
                id: 3,
                image: "/assets/HomeDecor/QR_code.webp",
                tag: "eStore",
                icon: "/assets/petStore/loyalty_new.svg",
                 title: "Let customers furnish their space from anywhere",
                desc: "Bring your physical store online with QueueBuster’s eStore feature. Display products with rich visuals and enable online ordering for home delivery or in-store pickup.",
                imageWidth: "46rem",
                imageHeight: "40.3rem",
                btnText: "Talk to an expert",
                
                Image1: {
                    src: "/assets/HomeDecor/Cart_Statistic.svg",
                    alt: "Pet Store Image 1",
                    imageWidth: "21rem",
                    imageHeight: "18rem",
                    top: "2rem",
                    right: "3rem",
                    
                },
                 Image3: {
                    src: "/assets/HomeDecor/vase.svg",
                    alt: "Pet Store Image 4",
                    imageWidth: "15rem",
                    imageHeight: "15rem",
                    bottom: "2rem",
                    left: "0rem",
                    
                },
               
                points: [
                    <>Build a digital storefront with product images, specs & prices</>,
                    <>Enable delivery, in-store pickup, or order reservations</>,
                    <>Share product links via WhatsApp, Instagram, or QR codes</>,
                    <>Sync inventory with your POS for a unified stock view</>
                ],
            },
            {
                id: 4,
                image: "/assets/HomeDecor/living_spaces.webp",
                tag: "Reporting & Analytics",
                icon: "/assets/petStore/online-shop.svg",
                title: "Know what’s trending in home decor and living spaces",
                desc: "Get deep insights into your store’s performance, popular products, and customer preferences. Make smarter decisions with real-time analytics.",
                imageWidth: "45rem",
                imageHeight: "45rem",
                btnText: "Request a callback",
                Image1: {
                    src: "/assets/HomeDecor/orderSummary.svg",
                    alt: "Pet Store Image 4",
                    imageWidth: "24rem",
                    imageHeight: "17rem",
                    top: "4rem",
                    right: "2rem",
                },
                Image2: {
                    src: "/assets/HomeDecor/listIcon.svg",
                    alt: "Pet Store Image 1",
                    imageWidth: "6rem",
                    imageHeight: "6rem",
                    bottom: "-2rem",
                    right: "40%",
                },
                Image3: {
                    src: "/assets/HomeDecor/Highdemand.svg",
                    alt: "Pet Store Image 3",
                    imageWidth: "20rem",
                    imageHeight: "8rem",
                    bottom: "10%",
                    left: "0rem",
                    
                },


                points: [
                    <>Sales reports by product, category, or staff</>,
                    <>Track footfall, basket size, and sales by time slot</>,
                    <>Understand top-selling SKUs and seasonal trends</>,
                    <>Generate GST-compliant invoices and tax reports</>,
                    <>Monitor discounts, returns, and margins</>
                ],
            },
            {
                id: 5,
                image: "/assets/HomeDecor/power_growth.webp",
                tag: "Seamless Integrations",
                icon: "/assets/petStore/loyalty_new.svg",
                title: "Integrations that power growth",
                desc: "Seamlessly connect your CRM, payment gateways, and ERP systems with QueueBuster’s dashboard to automate workflows, enrich customer experiences, and unlock business intelligence.",
                imageWidth: "46rem",
                imageHeight: "40.3rem",
                btnText: "Request a callback",
                Image1: {
                    src: "/assets/HomeDecor/amazon.svg",
                    alt: "Pet Store Image 4",
                    imageWidth: "10rem",
                    imageHeight: "5rem",
                    bottom: "5%",
                    right: "2rem",
                    
                },
                Image3: {
                    src: "/assets/HomeDecor/orders.svg",
                    alt: "Pet Store Image 1",
                    imageWidth: "25rem",
                    imageHeight: "12rem",
                    bottom: "2rem",
                    left: "0rem",
                   
                    
                },
                Image4: {
                    src: "/assets/HomeDecor/gPay.svg",
                    alt: "Pet Store Image 3",
                    imageWidth: "10rem",
                    imageHeight: "5rem",
                    top: "4rem",
                    left: "10rem",
                     
                },
                

                points: [
                    <>Sync customer data, purchase history & invoices via ERP integration</>,
                    <>Offer smooth checkouts and smart payment options with gateway integrations</>,
                    <>Automate rewards, refunds, and re-engagement campaigns through CRM </>,
                    <>Trigger personalized communication on birthdays, festivals & offers</>
                ],
            },
        ]
    };
     const CompanyLogos = [
    { imgSrc: "/assets/HomeLanding/QBIcons/heineken.svg", height:"10rem",width:"15rem", altText: "Heineken" },
    { imgSrc: "/assets/HomeLanding/QBIcons/bridgestone.svg",height:"10rem",width:"15rem", altText: "Bridgestone" },
    { imgSrc: "/assets/HomeLanding/QBIcons/itc.svg",height:"10rem",width:"15rem", altText: "ITCLimited" },
    { imgSrc: "/assets/HomeLanding/QBIcons/tajseats.svg",height:"10rem",width:"15rem", altText: "TajSats1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/irctc.svg",height:"10rem",width:"15rem",  altText: "irctc" },
    { imgSrc: "/assets/HomeLanding/QBIcons/cremica.svg",height:"10rem",width:"15rem",  altText: "Cremica" },
    { imgSrc: "/assets/HomeLanding/QBIcons/pansarigroup.svg",height:"10rem",width:"15rem",  altText: "PansariGroup" },
    { imgSrc: "/assets/HomeLanding/QBIcons/reshamandi.svg",height:"10rem",width:"15rem",  altText: "Reshamandi1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/selectcitywalk.svg",height:"10rem",width:"15rem", altText: "SelectCitywalk" },
    { imgSrc: "/assets/HomeLanding/QBIcons/cococart.svg",height:"10rem",width:"15rem", altText: "Cococart" },
    { imgSrc: "/assets/HomeLanding/QBIcons/emoi.svg",height:"10rem",width:"15rem", altText: "Emoi" },
    { imgSrc: "/assets/HomeLanding/QBIcons/candorfoods.svg",height:"10rem",width:"15rem",  altText: "CandorFoods" },
    { imgSrc: "/assets/HomeLanding/QBIcons/TirumalaTirupatiDevasthanams.svg",height:"10rem",width:"15rem",  altText: "TirumalaTirupatiDevasthanams" },
    { imgSrc: "/assets/HomeLanding/QBIcons/earthrhythm.svg",height:"10rem",width:"15rem",  altText: "ArthRhythm1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/hindustanunilever.svg",height:"10rem",width:"15rem",  altText: "HindustanUnileverLimited" },
    { imgSrc: "/assets/HomeLanding/QBIcons/genus.svg",height:"10rem",width:"15rem", altText: "Genus" },
    { imgSrc: "/assets/HomeLanding/QBIcons/dlfbrands.svg",height:"10rem",width:"15rem", altText: "DLFbrands" },
    { imgSrc: "/assets/HomeLanding/QBIcons/bayarscoffee.svg",height:"10rem",width:"15rem",  altText: "scoffee" },
    { imgSrc: "/assets/HomeLanding/QBIcons/continentalcoffee.svg",height:"10rem",width:"15rem", altText: "Continentalcoffee" },
    { imgSrc: "/assets/HomeLanding/QBIcons/plazalounge.svg",height:"10rem",width:"15rem", altText: "Plazapremiumlounge" },
    { imgSrc: "/assets/HomeLanding/QBIcons/mmmart.svg",height:"10rem",width:"15rem", altText: "Mart" },
    { imgSrc: "/assets/HomeLanding/QBIcons/wonderla.svg",height:"10rem",width:"15rem", altText: "wonderla" },
    { imgSrc: "/assets/HomeLanding/QBIcons/shivalaya1.svg",height:"10rem",width:"15rem", altText: "Shivalaya 1" },
    
   
]
const companyLogos2= [
     { imgSrc: "/assets/HomeLanding/QBIcons/organicharvest.svg", width:"15rem", height:"10rem", altText: "OrganicHarvest" },
    { imgSrc: "/assets/HomeLanding/QBIcons/nayara.svg",width:"15rem", height:"10rem", altText: "NayaraEnergy" },
    { imgSrc: "/assets/HomeLanding/QBIcons/premier.svg",height:"10rem",width:"15rem", altText: "Premier1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/orgalife.svg",height:"10rem",width:"15rem", altText: "Orgalife1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/smytten.svg",height:"10rem",width:"15rem", altText: "Smytten1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/flemingo.svg",height:"10rem",width:"15rem", altText: "Flemingo1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/aafarin.svg",height:"10rem",width:"15rem", altText: "Aafarin" },
    { imgSrc: "/assets/HomeLanding/QBIcons/redivy.svg",height:"10rem",width:"15rem", altText: "RedIvy1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/toscee.svg",height:"10rem",width:"15rem",  altText: "Toscee1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/jainshikanji.svg",height:"10rem",width:"15rem", altText: "Jainshikanji" },
    { imgSrc: "/assets/HomeLanding/QBIcons/34chowringlane.svg",height:"10rem",width:"15rem", altText: "34chowringheelane" },
    { imgSrc: "/assets/HomeLanding/QBIcons/tangelo.svg",height:"10rem",width:"15rem", altText: "Tangelo1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/canabeans.svg",height:"10rem",width:"15rem", altText: "Canabeans1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/thegulatigroup.svg",height:"10rem",width:"15rem",altText: "gulatigroup" },
    { imgSrc: "/assets/HomeLanding/QBIcons/gullynetwork.svg", height:"10rem",width:"15rem", altText: "Gullynetwork1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/mcd.svg",height:"10rem",width:"15rem", altText: "MCD1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/phl.svg",height:"10rem",width:"15rem", altText: "PHL1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/tistabene.svg",height:"10rem",width:"15rem", altText: "Tistabene1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/hokmakeup.svg",height:"10rem",width:"15rem", altText: "HOKmakeup1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/handfulofhealth.svg",height:"10rem",width:"15rem", altText: "Handfulofhealth" },
    { imgSrc: "/assets/HomeLanding/QBIcons/grihasthee.svg",height:"10rem",width:"15rem", altText: "grihasthee1" },
    // { imgSrc: "/assets/HomeLanding/QBIcons/relaxo.svg",height:"10rem",width:"15rem", altText: "relaxo" },
]
  


    return (
        <div style={{fontFamily:"GilroyMedium"}}>
            <HeroSection data={topSection} />
           <div style={{ maxWidth: "1850px", margin:"0 auto"}}>
              <div style={{ margin: "0rem 18rem 0 18rem", position: "relative", zIndex:1 }}>
                            <NewMarqueeComponentHomePageIndia
                             direction={'left'}
                                ClientsArr={CompanyLogos}
                                style={{
                                    width: "100%",
                                    backgroundColor: "transparent",
                                    display: "flex",
                                    justifyContent: "center",
                                    margin: "2rem auto",
                                }}
                            />
                            <NewMarqueeComponentHomePageIndia
                                ClientsArr={companyLogos2}
                                  
                                style={{
                                    width: "100%",
                                    backgroundColor: "transparent",
                                    display: "flex",
                                    justifyContent: "center",
                                    margin: "-3.5rem auto 0 auto",
                               
        
                                }}
                            />
                        </div>
           </div>

           <div className={styles.features_section}>
                <div className={styles.section_heading}><h1> Designed for Decor:<span style={{color:"#2A6AB4"}}> Features That Fit your Store </span></h1>
                </div>

            
            <FeaturesSection data={Data.data} centerImages={[Data.centerImage1]} />
            </div>
            <div className={styles.featuresSection}> 
                {/* <GetFreeTrial/> */}
                <div ><ReviewsSection /></div>
                <div><BusinessUnlockSection /></div>
                <div ><CaseStudiesSection /></div>
                <div style={{ margin: "0 0rem 8rem 0rem " }}> <ConnectWithUs /></div>
                
                <NewFaqSection FaqTableData={faqs} heading ={"FAQ’s for QB POS billing software for home & living stores."}  />
                <div>
                    <NewsAndVideos />
                </div>
            </div>

        </div>
    )
}


export default HomeLivingDesktop
